<template>
  <div class="layout-main-menu">
    <div class="menu-header">
      <div class="s-20 w-600 uppercase">Меню</div>
      <div class="close-button" @click="close">
        <icon-close></icon-close>
      </div>
    </div>
    <slot name="main-menu" :toggle="toggle" :isActive="isActive"></slot>
    <layout-main-menu-section
        :section="section"
        v-for="(section, index) in armainmenu"
        :key="index"
    ></layout-main-menu-section>
  </div>
</template>

<script>
export default {
  props: {
    armainmenu:{}
  },
  data() {
    return {
      //menu: {},
      isActive: false
    }
  },
  components: {
    'layout-main-menu-section': () => import('./main-menu/layout-main-menu-section.vue'),
    'icon-close': () => import('@/components/icon/icon-close.vue'),
  },
  methods: {
    close() {
      this.$emit('close')
    },
    toggle() {
      this.isActive = !this.isActive
    },
    /*
    async requestMenu(){
      await this.$axios({
        url: '/ajax/main-menu.php',
        method: 'post',
        data: {}
      }).then(response => {
        if (response.status == 200) {
          this.menu = response.data;
          document.getElementById('mainMenuHidden').style.display='none';
        } else {
          console.log("request main-menu error")
        }
      }).catch(e => {
        console.log('Error: ' + e);
      })
    },
    */
  },
  created() {
    //this.requestMenu();
  }
}
</script>

<style lang="scss">
.layout-main-menu {
  display: flex;
  align-items: stretch;
  justify-content: center;
  margin: auto;
  gap: 10px;
  position: relative;
  height: 100%;
  &:hover {
    .layout-main-menu-section {
      .section-name {
        opacity: 0.5;
      }
      &:hover {
        .section-name {
          opacity: 1;
        }
      }
    }
  }
}
.menu-header {
  display: none;
}
@media screen and (max-width: 1170px) {
  .layout-main-menu {
    position: fixed;
    z-index: 300;
    background: #fff;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: block;
    transform: translate3d(120vw, 0, 0);
    transition: 0.3s;
    &.open {
      transform: none;
    }
  }
  .menu-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 15px;
  }
}
</style>
<style lang="scss" scoped>

.section-menu-block {
  position: absolute;
  /*transform: translate3d(0, 10px, 0);*/
  width: 100%;
  left: 0;
  top: 100%;
  display: none;
}
.section-menu {
  background: #fff;
  padding: 10px;
  border-radius: 5px;
  width: 100%;
  box-shadow: 0px 30px 50px rgba(0, 0, 0, 0.4);
  max-height: 70vh;
}
.section-menu-inner {
  columns: 3;
  gap: 0px;
}
.section-name {
  cursor: pointer;
  transition: 0.3s;
  height: 100%;
  display: flex;
  align-items: center;
}
.link-section-all{
  column-span: all;
  padding-left: 15px;
}
.mobile {
  display: none;
}
.back-button {
  display: none;
}
// big screens
@media screen and (min-width: 1171px) {
  .layout-main-menu-section {
    display: flex;
    align-items: center;
    &:hover {
      .section-menu-block {
        /*opacity: 1;
        visibility: visible;
        transform: none;*/
        display: block;
      }
    }
    &.active {
      .section-menu-block {
        /*opacity: 1;
        visibility: visible;
        transform: none;*/
        display: block;
      }
    }
  }
}
.chevron {
  display: none;
}
@media screen and (max-width: 1170px) {
  .desktop {
    display: none !important;
  }
  .chevron {
    display: block;
  }
  .mobile {
    display: flex;
  }
  .section-menu-block {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    opacity: 0;
    visibility: hidden;
    transform: translate3d(120vw, 0, 0);
    z-index: 30;
    &.active {
      opacity: 1;
      visibility: visible;
      transform: none;
    }
  }
  .section-menu {
    padding: unset;
    width: 100%;
    height: 100%;
    background: var(--light);
    display: block;
    box-shadow: none;
    max-height: unset;
    &.active {
      transform: none;
    }
  }
  .section-name {
    font-size: 18px;
    padding: 13px 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    opacity: 1 !important;
  }
  .section-menu-inner {
    columns: unset;
  }
  .layout-main-menu-section {
    border-bottom: solid 1px var(--light);
  }
  .back-button {
    display: flex;
    align-items: center;
    padding: 15px 15px;
    gap: 6px;
  }
  .link-section-all{
    padding-left: 0;
  }
}

</style>
<style lang="scss" scoped>
.layout-main-menu-block {
  break-inside: avoid;
  margin-bottom: 30px;
  transition: 0.3s;
  position: relative;
  z-index: 0;
  padding: 15px;
  &:before {
    content: '';
    position: absolute;
    left: 0px;
    top: 0px;
    width: calc(100%);
    height: calc(100%);
    background: var(--light);
    z-index: -1;
    border-radius: 10px;
    opacity: 0;
    transition: 0.3s;
  }
  &:hover {
    &::before {
      opacity: 1;
    }
  }
  &:hover {
    .link {
      opacity: 0.5;
      &:hover {
        opacity: 1;
      }
    }
  }
}
.block-name {
  margin-bottom: 5px;
  display: block;
}
.link {
  text-transform: lowercase;
  margin-bottom: 5px;
  transition: 0.3s;
  display: block;
}
.chevron {
  display: none;
}
@media screen and (max-width: 1170px) {
  .layout-main-menu-block {
    margin-bottom: 10px;
    padding: unset;
    &:before {
      background: #fff;
      opacity: 1;
    }
  }
  .chevron {
    display: block;
  }
  .block-name {
    padding: 0px 15px;
    padding-top: 15px;
  }
  .link {
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 15px;
    margin-bottom: unset;
    &:not(:last-child) {
      border-bottom: solid 1px var(--light);
    }
    &:last-child {
      padding-bottom: 15px;
    }
  }
}
</style>
<style lang="scss" scoped>
.level3.active{
  z-index: 1 !important;
}
.level3 {
  .links{
    background: #fff;

    a {
      &.link {
        opacity: 1 !important;
      }
    }
  }
}
</style>